<template>
	<BasePublishCategory :root-category="true" :include-subcategories="true" v-slot="{item: category, rootCategory}" :seo="true" @data="onPageLoad">
		<CmsBreadcrumbs v-if="category?.breadcrumbs" :items="category.breadcrumbs" />
		<div class="p-header">
			<div class="wrapper">
				<h1>{{ category.seo_h1 }}</h1>
				<PublishWidgetSubcategories :category="category" :rootCategory="rootCategory" />
			</div>
		</div>

		<BasePublishPosts thumb-preset="publishEntry" featured-thumb-preset="publishBig" @load="loadPagination" :featured-posts="category.level <= 1 ? 1 : 0" v-slot="{items: posts, nextPage, loadMore, featuredPosts, loading}">
			<div class="wrapper" v-if="category.level <= 1 && featuredPosts">
				<div class="p-featured">
					<PublishIndexEntry :short-description="true" mode="big" v-for="featuredPost in featuredPosts" :key="featuredPost.id" :item="featuredPost" />
				</div>
			</div>

			<PublishWidgetSpecialPosts v-if="category.level <= 1" />

			<div class="wrapper">
				<div class="p-items" v-if="posts?.length">
					<PublishIndexEntry v-for="post in posts" :key="post.id" :item="post" :short-description="true" mode="small" />
				</div>
				<div v-else class="p-empty">{{ labels.get('no_publish') }}</div>

				<div class="load-more-container" v-if="posts?.length && nextPage" data-posts-scroll-trigger>
					<a href="javascript:void(0);" class="btn btn-white btn-medium load-more btn-load-more" :class="{'loading': loading}" @click="loadMore">{{ labels.get('load_more_publish') }}</a>
				</div>
				<BaseUiPagination class="pagination" />
			</div>
		</BasePublishPosts>
	</BasePublishCategory>
</template>

<script setup>
	const labels = useLabels();
	const route = useRoute();

	const objectToQueryString = (obj) => {
		return Object.entries(obj)
			.filter(([key, value]) => {
				// Include the key-value pair only if the value is not an empty array
				return !Array.isArray(value) || (Array.isArray(value) && value.length > 0);
			})
			.map(([key, value]) => {
				return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
			})
			.join('&');
	};

	//gtm
	const gtm = useGtmBB();
	let loadedCategoryData = ref(null);

	function onPageLoad(data) {
		if(!data) return;
		loadedCategoryData.value = data;

		gtm.pageView({
			url: data?.category?.value?.url || '',
			title: data?.category?.value?.title || '',
		});
	}

	function loadPagination() {
		const queryString = objectToQueryString(route?.query);
		const urlValue = queryString ? loadedCategoryData?.value?.category?.url + '?' + queryString : loadedCategoryData?.value?.category?.url;

		gtm.pageView({
			url: urlValue || '',
			title: loadedCategoryData?.value?.category?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	.p-header {
		padding: 25px 0 0;
		border-bottom: 1px solid @borderColor;

		@media (max-width: @t) {
			padding: 20px 0 0;
		}
		@media (max-width: @ms) {
			padding: 10px 0 0;
			border-bottom: none;
		}
	}
	.p-items {
		width: calc(~'100% - -30px');
		margin-left: -15px;
		display: flex;
		flex-wrap: wrap;
		padding-top: 30px;

		@media (max-width: @t) {
			width: calc(~'100% - -15px');
			margin-left: -7px;
			padding-top: 40px;
		}
		@media (max-width: @m) {
			width: calc(~'100% - -12px');
			margin-left: -6px;
			padding-top: 30px;
		}
		@media (max-width: @ms) {
			width: 100%;
			margin: 0;
			padding-top: 20px;
		}
	}
	.p-featured {
		padding: 40px 0;

		@media (max-width: @t) {
			padding: 30px 0;
		}
		@media (max-width: @ms) {
			padding: 10px 0;
		}
	}

	.p-empty {
		padding: 40px 0;

		@media (max-width: @t) {
			padding: 30px 0;
		}
	}
</style>
